module.exports = __webpack_public_path__ + "static/media/avoidcroud.96378169.svg";